import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { ConsentMasterModel } from '../models/consent-master.model';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BranchMatserService } from '../branch-matser.service';
import { AuthService } from 'app/auth/auth.service';
import { EMRService } from 'app/EMR/EMR.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { imageworkupService } from 'app/EMR/Image_workup/Services/Imageworkup.services';
import { WebSocketService } from 'app/EMR/webSocket.Service';

@Component({
  selector: 'app-consent-master',
  templateUrl: './consent-master.component.html',
  styleUrls: ['./consent-master.component.scss']
})
export class ConsentMasterComponent implements OnInit {
  OpTypeCtrl: FormControl;
  filteredOpTypeArray: Observable<any[]>;
  DocTypeCtrl: FormControl;
  filteredDocTypeArray: Observable<any[]>;
  consentMasterArray: ConsentMasterModel[] = [];
  consentMasterobj: ConsentMasterModel = {};
  getOPTypeArray: any = [];
  documenttypeArray: any = [];
  showspinner: any;
  searchConsent: any;
  get filteredConsentMaster(): ConsentMasterModel[] {
    const term = this.searchConsent?.toString().toLowerCase().trim();
    if (!term) {
      return this.consentMasterArray;
    }
    return this.consentMasterArray.filter(row =>
      row.documentType?.toLowerCase().includes(term) ||
      row.documentName?.toLowerCase().includes(term) ||
      row.operationTypeName?.toLowerCase().includes(term) 
    );
  }
  constructor(public dashboardService: DashboardService, public ipdService: IPDService, public branchservice: BranchMatserService,
    public authservice: AuthService, public emrservice: EMRService, public opdvisitService: OpdVisitService, private imageWorkupService: imageworkupService, private webSocketService: WebSocketService) { }

  ngOnInit(): void {
    this.getOtConsent();
    this.GetotTypeData();
    this.gettypeBYname();
    this.DocTypeCtrl = new FormControl();
    this.clearconsentdata();
  }


  gettypeBYname() {
    this.branchservice.getNamebyType('DOCUMENTTYPE').subscribe((x: any) => {
      this.documenttypeArray = [];
      this.documenttypeArray = x;
      this.DocTypeControll();
    }, err => {
      this.dashboardService.openSnackBar("API Failed", "OK");
    })
  }
  //Get Opertation Type
  GetotTypeData() {
    this.getOPTypeArray = [];
    try {
      this.ipdService.GetOPType().subscribe(item => {
        this.getOPTypeArray = item;
        this.OpTypeControll();
      });
    }
    catch (e) {

    }
  }
  DocTypeControll() {
    this.DocTypeCtrl = new FormControl();
    this.filteredDocTypeArray = this.DocTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterDocfunction(cat) : this.documenttypeArray.slice())
      );
  }
  filterDocfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.documenttypeArray.filter(item =>
        item.name?.toLowerCase().indexOf(name) === 0);
    } else {

      return this.documenttypeArray.filter(item =>
        item.name?.toLowerCase().indexOf(name?.toLowerCase()) === 0);
    }

  }
  OpTypeControll() {

    this.OpTypeCtrl = new FormControl();
    this.filteredOpTypeArray = this.OpTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterOpfunction(cat) : this.getOPTypeArray.slice())
      );

  }
  filterOpfunction(name: string) {

    const len = Object.keys(name).length;
    if (len > 9) {
      return this.getOPTypeArray.filter(country =>
        country.operationTypeName?.toLowerCase().indexOf(name) === 0);
    } else {

      return this.getOPTypeArray.filter(country =>
        country.operationTypeName?.toLowerCase().indexOf(name?.toLowerCase()) === 0);
    }

  }
  getDOcTypeobj(e: any) {
    var val = e.option.value;
    this.consentMasterobj.documentType = val.name;
  }
  CheckinputDocType(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.DocTypeControll();
    }
  }
  opTypeName: any;
  getOpTypeobj(e: any) {
    var val = e.option.value;
    this.consentMasterobj.operationTypeName = val.operationTypeName;
    this.consentMasterobj.fK_OperationTypeID = val.pK_OperationTypeId;
  }
  Doucmentdata(row: any) {
    this.consentMasterobj = row;
    this.consentMasterobj.isEdit = true;
    document.getElementById("consentDocumentRecordModal").style.display = 'none';
  }
  CheckinputOpType(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.OpTypeControll();
    }
  }
  closeconsentDocumentModal() {
    document.getElementById("consentDocumentRecordModal").style.display = 'none';
    this.searchConsent = ''
  }
  openConsentDocument() {
    this.clearconsentdata();
    document.getElementById("consentDocumentRecordModal").style.display = 'block';
    this.getOtConsent()
  }

  getOtConsent() {
    this.branchservice.GetDocumentMaster(0, 0).subscribe((x: any) => {
      this.consentMasterArray = [];
      if (x.length > 0) {
        this.consentMasterArray = x;
      }
    }, err => {
      this.dashboardService.openSnackBar("API FAILED", "OK");
    })
  }
  clearconsentdata() {
    this.consentMasterobj = {};
    this.consentMasterobj.pK_DocumentId = 0;
    this.consentMasterobj.Fk_PartyID = null;
    this.consentMasterobj.documentDescription = null;
    this.consentMasterobj.documentName = null;
    this.consentMasterobj.fK_OperationTypeID = 0;
    this.consentMasterobj.isEdit = false;
    this.consentMasterobj.isActive = false;
    this.consentMasterobj.documentType = null;
    this.consentMasterobj.isDigitalSignature = true;
    this.consentMasterobj.operationTypeName = null;
  }
  insetupdatedata(event) {
    const selectedDocType = this.documenttypeArray.find(
      (doc) => doc.name?.toLowerCase() == this.consentMasterobj.documentType?.toLowerCase()
    );

    if (!selectedDocType) {
      return this.dashboardService.openSnackBar("Please select a valid Document Type", "OK");
    }

    const selectedOpType = this.getOPTypeArray.find(
      (op) => op.operationTypeName?.toLowerCase() == this.consentMasterobj.operationTypeName?.toLowerCase()
    );

    if (!selectedOpType) {
      return this.dashboardService.openSnackBar("Please select a valid Operation Type", "OK");
    }

    if (this.consentMasterobj.pK_DocumentId == 0) {
      let chekcdublicate = this.consentMasterArray.filter(item => item.documentType.toLowerCase() == this.consentMasterobj.documentType.toLowerCase() && item.documentName.toLowerCase() == this.consentMasterobj.documentName.toLowerCase());
      if (chekcdublicate.length > 0) {
        return this.dashboardService.openSnackBar("Already Exist in the list", "OK");
      }
    }
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 1000);
    let payLoad = {
      "DocumentMaster": this.consentMasterobj
    }
    this.branchservice.InsertDocumentMaster(payLoad).subscribe((x: any) => {
      if (this.consentMasterobj.pK_DocumentId > 0) {
        this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
      } else {
        this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
      }
      this.getOtConsent();
      this.clearconsentdata();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  onFileChange(event) {

    if (this.authservice.Loggeduser.userid && this.consentMasterobj.pK_DocumentId > 0 && this.consentMasterobj.documentName != null) {
      var url = '';
      if (event.target.files.length > 0) {
        const filedata = event.target.files[0];

        let fnsplit = filedata.name.slice(-3);

        if (fnsplit.toLowerCase() == 'pdf') {
          var reader = new FileReader();
          reader.readAsDataURL(event.target.files[0]);
          reader.onload = (event: any) => {
            url = event.target.result;

          }
          if (this.authservice.webstorageConfigobj.storageType != null && this.authservice.webstorageConfigobj.storageType != undefined) {
            if (this.authservice.webstorageConfigobj.imageFileSize != null && this.authservice.webstorageConfigobj.imageFileSize != undefined && Number(this.authservice.webstorageConfigobj.imageFileSize) > 0) {
              if (Number(this.authservice.webstorageConfigobj.imageFileSize) * 1024 >= event.target.files[0].size) {
                this.opdvisitService.dataSource = [];
                this.imageWorkupService.getAzureImagedata(this.consentMasterobj.pK_DocumentId, this.authservice.Loggeduser.branchid, this.consentMasterobj.documentType).subscribe(
                  (data: any) => {
                    this.opdvisitService.dataSource = data;
                    this.showspinner = true;

                    const formData = new FormData();
                    let actualdocumentname = 'OTConsent_' + this.consentMasterobj.pK_DocumentId + "." + fnsplit;
                    formData.append('file', filedata, actualdocumentname);
                    formData.append('documentname', this.consentMasterobj.documentName);
                    formData.append('patientid', this.consentMasterobj.pK_DocumentId.toString());
                    formData.append('branchId', this.authservice.Loggeduser.branchid.toString());
                    formData.append('DocumentType', this.consentMasterobj.documentType);
                    formData.append('FolderNameMain', this.consentMasterobj.documentType);
                    formData.append('UserId', this.authservice.Loggeduser.userid.toString());
                    formData.append('PkTranId', this.opdvisitService.dataSource.length > 0 ? this.opdvisitService.dataSource[0]?.pk_TranId.toString() : '0');
                    formData.append('ActionType', "UPLOAD");
                    formData.append('StorageType', this.authservice.webstorageConfigobj.storageType);
                    formData.append('DocumentURL', '');
                    if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'server') {
                      this.dashboardService.subscriptions = this.imageWorkupService.uploadDoc(formData)
                        .subscribe(
                          data => this.successfileupload(data), err => this.failedfileupload(err));

                    } else if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'azure') {
                      this.imageWorkupService.uploadAzureDoc(formData)
                        .subscribe(
                          data => this.successfileupload(data), err => this.failedfileupload(err))
                    } else if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'aws') {

                    } else if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {

                      var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
                      if (mainimagepath.length > 0) {
                        if (mainimagepath[0]?.propertyValue) {
                          const splitdata = url.split(',');
                          const message = {
                            "message": "UPLOADFILE",
                            "ACTIONTYPE": "UPLOAD",
                            "DOCUMENTTYPE": this.consentMasterobj.documentType,
                            "BranchId": this.authservice.Loggeduser.branchid.toString(),
                            "PATIENTID": this.consentMasterobj.pK_DocumentId.toString(),
                            "MAINIMAGEPATH": mainimagepath[0]?.propertyValue,
                            "DOCUMENTNAME": String(actualdocumentname),
                            "CLIENTFILE": String(actualdocumentname),
                            "fileData": String(splitdata[1])
                          };

                          this.webSocketService.sendMessage(message);
                          this.webSocketService.getMessages().subscribe(
                            (message: any) => {

                              if (message) {
                                this.dashboardService.openSnackBar(message, "OK");
                                this.webSocketService.disconnect();
                                this.showspinner = false;
                                let payload = {
                                  "PatientDocumentDetail": {
                                    "ActionType": "UPLOAD",
                                    "Pk_TranId": this.opdvisitService.dataSource.length > 0 ? this.opdvisitService.dataSource[0].pk_TranId.toString() : '0',
                                    "Fk_BranchId": this.authservice.Loggeduser.branchid.toString(),
                                    "Fk_RegId": this.consentMasterobj.pK_DocumentId.toString(),
                                    "Fk_CreatedById": this.authservice.Loggeduser.userid,
                                    "DocumentType": this.consentMasterobj.documentType.toUpperCase(),
                                    "DocumentName": String(actualdocumentname),
                                    "StorageType": this.authservice.webstorageConfigobj.storageType,
                                    "DocumentURL": mainimagepath[0]?.propertyValue + '/' + this.consentMasterobj.documentType.toUpperCase() + '/' + actualdocumentname
                                  }
                                }
                                this.imageWorkupService.UpdatePatientDocumentDetail(payload).subscribe((x: any) => {


                                });
                              }

                            }, err => {
                              this.showspinner = false;
                              this.dashboardService.openSnackBar("Please set server configuration", "OK");
                            });
                        } else {
                          this.showspinner = false;
                          this.dashboardService.openSnackBar('Please set MainImagePath Property value in Application Setting', 'OK');
                        }
                      } else {
                        this.showspinner = false;
                        this.dashboardService.openSnackBar('Please set MainImagePath in Application Setting', 'OK');
                      }
                    } else {
                      this.showspinner = false;
                      this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
                    }
                  }, err => {
                    if (err.status == 403) {
                      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                    }
                    else if (err.error.statusCode == 422) {
                      this.dashboardService.openSnackBar(err.error.message, "OK");
                    }
                    else {
                      this.dashboardService.openSnackBar("API Failed", "OK");
                    }
                  });
              } else {
                this.showspinner = false;
                this.dashboardService.openSnackBar("Maximum File Size Allowed " + this.authservice.webstorageConfigobj.documentFileSize + ' Kb', "OK");
              }
            } else {
              this.showspinner = false;
              this.dashboardService.openSnackBar("Document File Size Not Configured", "OK");
            }
          } else {
            this.showspinner = false;
            this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
          }


        } else {
          this.showspinner = false;
          this.dashboardService.openSnackBar("Please Select PDF File", "OK");
        }
      }
    }
    else {
      this.showspinner = false;
      this.dashboardService.openSnackBar("Please Select Document OR Save Document First", "OK");
    }

  }
  failedfileupload(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {

      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  successfileupload(data) {
    this.showspinner = false;
    this.dashboardService.openSnackBar("Uploaded Successfully", "OK");
  }


}
